import React, { useEffect, useState } from "react";
import {
  Box,
  TextField,
  Typography,
  CircularProgress,
  MenuItem,
  Modal
} from "@mui/material";
import MDButton from "components/MDButton";
import DataTable from "examples/Tables/DataTable"; // asumiendo que este es tu DataTable
const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 450,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
};

export default function EstudiantesPorGrupoMateria() {
  const [grupos, setGrupos] = useState([]);
  const [materias, setMaterias] = useState([]);
  const [grupoId, setGrupoId] = useState("");
  const [materiaId, setMateriaId] = useState("");
  const [estudiantes, setEstudiantes] = useState([]);
  const [loading, setLoading] = useState(false);
  const user = JSON.parse(sessionStorage.getItem("user"));
  const rol = user?.rol;
  const hoyStr = new Date().toLocaleDateString("en-CA");
  const [fecha, setFecha] = useState(hoyStr);
  const [modoRiesgo, setModoRiesgo] = useState(false);

  // 🔥 2. Estados para el Modal del Reporte
  const [openReporte, setOpenReporte] = useState(false);
  const [fechaInicio, setFechaInicio] = useState("");
  const [fechaFin, setFechaFin] = useState("");
  const [formato, setFormato] = useState("pdf");

 const handleMarcarAbandono = async (row) => {
  const confirmar = window.confirm(`¿Estás seguro de marcar a ${row.nombre} como ABANDONO?`);
  if (!confirmar) return;

  try {
    const token = sessionStorage.getItem("access_token");
    
    // 🔥 Capturamos el ID del usuario. Si el backend lo devuelve como `id`, `user_id` o `usuario_id`
    const usuarioIdReal = row.usuario_id || row.user_id || row.id;

    const res = await fetch(`${process.env.REACT_APP_API_URL}/marcar-abandono`, {
      method: "PUT",
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        usuario_id: usuarioIdReal, // 👈 Se envía el ID del alumno
        grupo_id: grupoId,        // 👈 Se envía el grupo que tienes arriba seleccionado en el Select
      }),
    });

    const data = await res.json();
    if (res.ok && data.success) {
      alert("✅ " + data.message);
      buscarEstudiantesRiesgo(); // Recarga la tabla para que desaparezca
    } else {
      alert("❌ " + (data.message || "No se pudo actualizar el estado"));
    }
  } catch (error) {
    console.error("Error en la conexión:", error);
    alert("❌ Error de comunicación con el servidor.");
  }
};

  const buscarEstudiantesRiesgo = async () => {
    if (!grupoId || !materiaId) {
      alert("Seleccione grupo y materia");
      return;
    }

    setLoading(true);
    try {
      const token = sessionStorage.getItem("access_token");
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/grupo/${grupoId}/materia/${materiaId}/estudiantes-riesgo`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const data = await res.json();

      // Seteamos los estudiantes con un estado de lectura (porque no vas a guardar asistencia de riesgo)
      setEstudiantes(data.map(est => ({ ...est, asistencia: 0 }))); 
      setModoRiesgo(true);
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  };
  
  // =========================
  // CARGAR GRUPOS Y MATERIAS
  // =========================
  useEffect(() => {
    const fetchGrupos = async () => {
      try {
        const token = sessionStorage.getItem("access_token");
        const res = await fetch(`${process.env.REACT_APP_API_URL}/docente/grupos`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = await res.json();
        setGrupos(data);
      } catch (error) {
        console.error("Error cargando grupos", error);
      }
    };
    fetchGrupos();
  }, []);

  useEffect(() => {
    if (!grupoId) return;

    const fetchMaterias = async () => {
      try {
        const token = sessionStorage.getItem("access_token");
        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/grupos/${grupoId}/materias`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        const data = await res.json();
        setMaterias(Array.isArray(data) ? data : data.data || []);
      } catch (error) {
        console.error("Error cargando materias", error);
      }
    };

    fetchMaterias();
  }, [grupoId]);

  // =========================
  // BUSCAR ESTUDIANTES
  // =========================
  const handleBuscar = async () => {
    if (!grupoId || !materiaId) {
      alert("Seleccione grupo y materia");
      return;
    }

    setLoading(true);
    try {
      const token = sessionStorage.getItem("access_token");
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/grupo/${grupoId}/materia/${materiaId}/asistencia`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const data = await res.json();
      console.log("Datos recibidos del backend:", data);
      // agregar campo asistencia por defecto 1 (presente)
      const dataConAsistencia = data.map((est) => ({
        ...est,
        asistencia: est.estado
          ? est.estado === "asistio"
            ? 1
            : est.estado === "tarde"
            ? 2
            : est.estado === "falta"
            ? 0
            : 0
          : 0,
      }));
      setEstudiantes(dataConAsistencia);
    } catch (error) {
      console.error("Error al cargar estudiantes", error);
    }
    setLoading(false);
  };

  // =========================
  // CAMBIAR ASISTENCIA
  // =========================
  const handleAsistenciaChange = (index, valor) => {
    const nuevos = [...estudiantes];
    nuevos[index].asistencia = valor;
    setEstudiantes(nuevos);
  };

  // =========================
  // GUARDAR ASISTENCIA
  // =========================
  const guardarAsistencia = async () => {
    if (!grupoId || !materiaId) {
      alert("Seleccione grupo y materia");
      return;
    }

    if (fecha > hoyStr) {
      alert("No puedes pasar asistencia de días futuros.");
      return;
    }

    const payload = {
      fecha,
      grupo_id: Number(grupoId),
      materia_id: Number(materiaId),

      asistencia: estudiantes.map((est) => ({
        inscripcion_id: est.inscripcion_id,
        inscripcion_capacitacion_id: est.inscripcion_capacitacion_id || null,
        estado: Number(est.asistencia),
        materia_id: Number(materiaId),
      })),
    };

    try {
      const token = sessionStorage.getItem("access_token");
      const res = await fetch(`${process.env.REACT_APP_API_URL}/asistencia`, {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Accept": "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (res.ok) {
        alert("Asistencia guardada correctamente");
      } else {
        console.log(data);
        alert(data.message || "Error al guardar asistencia");
      }

    } catch (error) {
      console.error(error);
      alert("Error al enviar asistencia");
    }
  };
  const handleImprimirReporte = () => {
    if (!fechaInicio || !fechaFin) {
      alert("Por favor seleccione ambas fechas");
      return;
    }
    const token = sessionStorage.getItem("access_token");
    const query = `?grupo_id=${grupoId}&materia_id=${materiaId}&fecha_inicio=${fechaInicio}&fecha_fin=${fechaFin}&formato=${formato}&token=${token}`;
    const url = `${process.env.REACT_APP_API_URL}/reportes/asistencia${query}`;
    
    window.open(url, "_blank");
    setOpenReporte(false);
  };

  const columns = [
    { Header: "#", accessor: "index", align: "center" },
    { Header: "Nombre", accessor: "nombre" },
    { Header: "Codigo", accessor: "codigo" },

    ...(modoRiesgo
      ? [
          {
            Header: "Total Faltas",
            accessor: "total_faltas",
            align: "center",
            Cell: ({ value }) => (
              <span style={{ color: "red", fontWeight: "bold" }}>
                {value || 0} Faltas
              </span>
            ),
          },
          ...(rol !== 3 && rol !== 4
            ? [
                {
                  Header: "Acción",
                  accessor: "acciones",
                  align: "center",
                  Cell: ({ row }) => (
                    <MDButton
                      variant="contained"
                      color="error"
                      size="small"
                      onClick={() => handleMarcarAbandono(row.original)}
                    >
                      Dar de Baja
                    </MDButton>
                  ),
                },
              ]
            : []),
        ]
      : [
          // 🟢 2. Si NO estamos en modo riesgo, mostramos el pasar lista convencional
          {
            Header: "Asistencia",
            accessor: "asistencia",
            align: "center",
            Cell: ({ row }) => (
              <TextField
                select
                size="small"
                value={row.original.asistencia}
                onChange={(e) => handleAsistenciaChange(row.index, Number(e.target.value))}
              >
                <MenuItem value={1}>Presente</MenuItem>
                <MenuItem value={0}>Falta</MenuItem>
                <MenuItem value={2}>Tarde</MenuItem>
              </TextField>
            ),
          },
        ]),
  ];

  // preparar filas para DataTable
  const rows = estudiantes.map((est, idx) => ({
    ...est,
    index: idx + 1,
    nombre: `${est.name} ${est.apellido_paterno} ${est.apellido_materno}`,
  }));

  return (
    <Box p={3}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h5" fontWeight="bold">
          📚 Registro de Asistencia
        </Typography>
        
        {rol != 3 && (
          <MDButton variant="contained" color="secondary" onClick={() => setOpenReporte(true)} disabled={!grupoId || !materiaId}>
            📊 Reporte de Asistencia
          </MDButton>
        )}
      </Box>

      {/* COMBOS Y BOTÓN */}
      <Box display="grid" gridTemplateColumns="repeat(auto-fill, minmax(200px, 1fr))" gap={2} mb={3} alignItems="center">
        <TextField
          label="Fecha de la Clase"
          type="date"
          value={fecha}
          onChange={(e) => setFecha(e.target.value)}
          InputLabelProps={{ shrink: true }}
          fullWidth
          inputProps={{ 
            min: hoyStr, // 🔒 No deja poner fechas de ayer ni anteriores
            max: hoyStr  // 🔒 No deja poner fechas de mañana ni futuras
          }} 
        />

        <TextField
          select
          label="Grupo"
          value={grupoId}
          onChange={(e) => setGrupoId(e.target.value)}
          SelectProps={{ native: true }}
          fullWidth
        >
          <option value=""></option>
          {grupos.map((g) => (
            <option key={g.id} value={g.id}>
              {g.nombre}
            </option>
          ))}
        </TextField>

        <TextField
          select
          label="Materia"
          value={materiaId}
          onChange={(e) => setMateriaId(e.target.value)}
          SelectProps={{ native: true }}
          fullWidth
          disabled={!grupoId}
        >
          <option value=""></option>
          {Array.isArray(materias) &&
          materias.map((m) => (
            <option key={m.materia_id} value={m.materia_id}>
              {m.nombre_materia}
            </option>
          ))}
        </TextField>

        <MDButton variant="contained" color="info" onClick={handleBuscar} sx={{ height: "45px" }}>
          Buscar Estudiantes
        </MDButton>
        <MDButton 
        variant={modoRiesgo ? "contained" : "outlined"} 
        color="error" 
        onClick={() => {
          if (modoRiesgo) {
            handleBuscar();
            setModoRiesgo(false);
          } else {
            buscarEstudiantesRiesgo();
          }
        }} 
        disabled={!grupoId || !materiaId}
        sx={{ height: "45px" }}
      >
        {modoRiesgo ? "👀 Ver Todos" : "🚨 +3 Faltas"}
      </MDButton>
      </Box>

      {/* DATATABLE */}
      {loading ? (
        <Box display="flex" justifyContent="center" mt={3}>
          <CircularProgress />
        </Box>
      ) : (
        estudiantes.length > 0 && (
          <>
            <DataTable
              table={{ columns, rows }}
              isSorted={false}
              entriesPerPage={false}
              showTotalEntries={false}
              pagination={false}
              noEndBorder
            />

            <Box display="flex" justifyContent="flex-end" mt={2}>
              <MDButton variant="contained" color="success" onClick={guardarAsistencia}>
                Guardar Asistencia
              </MDButton>
            </Box>
          </>
        )
      )}
      <Modal open={openReporte} onClose={() => setOpenReporte(false)}>
        <Box sx={modalStyle} display="flex" flexDirection="column" gap={3}>
          <Typography variant="h6" fontWeight="bold">
            Reporte de Asistencia Consolidada
          </Typography>
          
          <Typography variant="body2" color="textSecondary">
            Se generará un registro de asistencia para el grupo y materia seleccionados.
          </Typography>

          <Box display="flex" gap={2}>
            <TextField
              label="Fecha Inicio"
              type="date"
              value={fechaInicio}
              onChange={(e) => setFechaInicio(e.target.value)}
              InputLabelProps={{ shrink: true }}
              fullWidth
            />
            <TextField
              label="Fecha Fin"
              type="date"
              value={fechaFin}
              onChange={(e) => setFechaFin(e.target.value)}
              InputLabelProps={{ shrink: true }}
              fullWidth
            />
          </Box>

          <TextField
            select
            label="Formato de Documento"
            SelectProps={{ native: true }}
            value={formato}
            onChange={(e) => setFormato(e.target.value)}
            fullWidth
          >
            <option value="pdf">Documento PDF</option>
            <option value="excel">Documento Excel</option>
          </TextField>

          <Box display="flex" justifyContent="flex-end" gap={1} mt={1}>
            <MDButton variant="outlined" color="secondary" onClick={() => setOpenReporte(false)}>
              Cancelar
            </MDButton>
            <MDButton variant="contained" color="info" onClick={handleImprimirReporte}>
              Generar Reporte
            </MDButton>
          </Box>
        </Box>
      </Modal>

      {(!loading && estudiantes.length === 0) && (
        <Typography align="center" mt={3}>
          No hay estudiantes
        </Typography>
      )}
    </Box>
  );
}